import { IApplicationState, TBoardId } from 'app/types/types';
import { ICardPropertyOption } from 'app/types/rest/IRestBoardMeta';
import {
    getBoardCardCustomPropertyOptions
} from 'app/store/model/board/selectors/getBoardCardCustomPropertyOptions';
import {
    getBoardCustomProperties
} from '../../../../CardCustomProperties/hocs/CustomPropertiesHOC/selectors/getBoardCustomProperties';

export const toggleCardDefaultCustomPropertyOptions = (
    state: IApplicationState,
    boardId: TBoardId,
    option: string
): ICardPropertyOption[] => {
    const cardCustomProperties = getBoardCardCustomPropertyOptions(state, boardId);

    return getBoardCustomProperties(state, boardId).map((customProperty) => {
        const property = cardCustomProperties.find(({ option }) => option === customProperty.id);
        if (option === customProperty.id) {
            const isDefault = !property?.isDefault;
            return {
                option: customProperty.id,
                name: customProperty.name,
                isDefault,
                isRequired: false,
            };
        }
        return {
            option: customProperty.id,
            name: customProperty.name,
            isDefault: property && property.isDefault,
            isRequired: property && property.isRequired,
        };
    });
};
